import { Minus } from 'react-feather'

import { GetMyInfosQuery } from '@/core/graphql/types'

type VitalSignsProps = {
  consultation: GetMyInfosQuery['myInfos']['consultations'][number]
}

export function VitalSigns({ consultation }: VitalSignsProps) {
  return (
    <section className="flex flex-col gap-2 w-full">
      <h3 className="section-title">Signes vitaux</h3>
      <div className="rounded-lg mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3">
        {consultation.mesures.map((measure, idx) => (
          <div key={idx} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <p className="truncate text-sm font-medium text-gray-500">
              {measure.label} {measure.unit && `(${measure.unit})`}
            </p>
            <p className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
              {measure.value ? measure.value : <Minus className="text-zinc-500 text-md" />}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
